import * as React from "react";

const SvgRefluxL2 = ({ rackColor = "#001D3D" , ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="350"
    height="88"
    fill="none"
    viewBox="0 0 350 88"
    {...props}
  >
    <path
      fill={rackColor}
      d="M7.961 65H164l-7.961 23H0zM162.563 0H350l-9.563 23H153z"
    ></path>
      <path
d="M7.961 65H164l-7.961 23H0zM162.563 0H350l-9.563 23H153z"
      fill="none"
      stroke="black"
      strokeWidth="0.8"
    />
  </svg>
);

export default SvgRefluxL2;
